/**
 * Table column configuration for the unified products list.
 * `locked: true` columns cannot be hidden via the field selector.
 */
export const REPORT_TABLE_COLUMNS = [
    {field: 'title', headerName: 'Product name', editable: true, flex: 3, locked: true},
    {field: 'icrSubject', headerName: 'Related ICR', editable: false, flex: 2},
    {field: 'userDisplayName', headerName: 'Owner', editable: true, flex: 1},
    {field: 'productType.label', headerName: 'Product Type', editable: true, flex: 1},
    {field: 'updatedAt', headerName: 'Last Updated', editable: true, flex: 1},
    {field: 'status', headerName: 'Status', editable: true, flex: 1},
    {field: 'disclosureCount', headerName: 'Disclosures', editable: false, flex: 1},
];

/** Master list of columns the field selector can toggle for the products list. */
export const AVAILABLE_PRODUCT_COLUMNS = REPORT_TABLE_COLUMNS;

/** Default visible column fields (all of them). */
export const DEFAULT_VISIBLE_COLUMN_FIELDS = REPORT_TABLE_COLUMNS.map((c) => c.field);

/** Drafts list — includes linked ICR subject for collection-driven products. */
export const DRAFTS_TABLE_COLUMNS = [
    {field: 'title', headerName: 'Product name', editable: true, flex: 2},
    {field: 'icrSubject', headerName: 'Related ICR', editable: false, flex: 2},
    {field: 'userDisplayName', headerName: 'Owner', editable: true, flex: 1},
    {field: 'productType.label', headerName: 'Product Type', editable: true, flex: 1},
    {field: 'updatedAt', headerName: 'Last Updated', editable: true, flex: 1},
    {field: 'status', headerName: 'Status', editable: true, flex: 2},
];

/**
 * Table column configuration for FINTEL reports list
 * FINTEL reports show disclosures instead of status
 */
export const FINTEL_TABLE_COLUMNS = [
    {field: 'title', headerName: 'Product name', editable: true, flex: 2},
    {field: 'icrSubject', headerName: 'Related ICR', editable: false, flex: 2},
    {field: 'userDisplayName', headerName: 'Owner', editable: true, flex: 1},
    {field: 'productType.label', headerName: 'Product Type', editable: true, flex: 1},
    {field: 'updatedAt', headerName: 'Last Updated', editable: true, flex: 1},
    {field: 'disclosureCount', headerName: 'Disclosures', editable: true, flex: 1},
];

/**
 * Disclosures list — status as badge; parent FINTEL link column.
 */
export const DISCLOSURE_TABLE_COLUMNS = [
    {field: 'title', headerName: 'Disclosure', editable: true, flex: 2},
    {field: 'parentTitle', headerName: 'Parent FINTEL', editable: false, flex: 2},
    {field: 'userDisplayName', headerName: 'Owner', editable: true, flex: 1},
    {field: 'meta.selectedCountries', headerName: 'Recipient', editable: true, flex: 1},
    {field: 'updatedAt', headerName: 'Last Updated', editable: true, flex: 1},
    {field: 'status', headerName: 'Status', editable: true, flex: 1},
];

